'use client';

import React from 'react';
import { BiX } from 'react-icons/bi';

interface ModalHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  onClose?: () => void;
  variant?: 'default' | 'dark';
  className?: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  subtitle,
  icon,
  onClose,
  variant = 'default',
  className = '',
}) => {
  const isDark = variant === 'dark';

  return (
    <div
      className={`flex items-start gap-3 p-6 rounded-t-2xl ${
        isDark ? 'bg-[#0f1f4b] text-white' : 'bg-white text-[#0f1f4b]'
      } ${className}`}
    >
      {icon && (
        <div
          className={`w-10 h-10 rounded-xl flex items-center justify-center ${
            isDark ? 'bg-white/10' : 'bg-blue-50 text-blue-500'
          }`}
        >
          {icon}
        </div>
      )}

      <div className="flex-1 min-w-0">
        <h2 className="text-lg font-bold truncate">{title}</h2>
        {subtitle && (
          <p
            className={`mt-1 text-xs ${
              isDark ? 'text-blue-100' : 'text-gray-500'
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>

      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className={`ml-2 rounded-full p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 cursor-pointer ${
            isDark ? 'hover:bg-white/10 hover:text-white' : ''
          }`}
        >
          <BiX size={20} />
        </button>
      )}
    </div>
  );
};

